import { Component, Input, OnInit } from "@angular/core";

import { FEATURE_FLAGS } from "src/app/constants/feature-flags";
import { User } from "src/app/models/identity/user.model";
import { AccountsService } from "src/app/services/identity/accounts.service";
import { ChatBridgeService } from "src/app/services/shared/chat-bridge.service";
import { PosthogService } from "src/app/services/shared/posthog.service";

@Component({
  selector: 'app-private-conversation-button',
  templateUrl: './private-conversation-button.component.html',
  styleUrls: ['./private-conversation-button.component.scss']
})
export class PrivateConversationButtonComponent implements OnInit {
  @Input() public isRounded = false;
  public showChatButton: boolean;
  @Input() public user: User | null = null;

  constructor(
    private readonly chatBridgeService: ChatBridgeService,
    public readonly accountsService: AccountsService,
    private readonly posthogService: PosthogService,
  ) {}

  public get isCurrentUser(): boolean {
    return this.accountsService.currentUser?.userId === this.user?.userId;
  }

    public ngOnInit(): void {
        this.showChatButton = this.posthogService.isFeatureEnabled(FEATURE_FLAGS.PSCC_CONNECT_LAUNCH);
    }

  public onOpenConversation(event: Event): void {
    event.stopPropagation();
    if (this.user) {
      this.chatBridgeService.openConversation(this.user);
    }
  }
}
